import React, { Component} from 'react';

import Select from './../Select';

const data = [{
    value: 2,
    label: "不参与"
},{
    value: 1,
    label: "参与"
}];

const IsEvalMutual = (props) => (
    <Select name="isEvalMutual" label="是否参与互评" data={data} {...props} ></Select>
);

export default IsEvalMutual;